//  TODO: have this constant in erisxkit
const RPC_TIMEOUT = 600000;
// specify a timeout in millis for axios requests within setInterval
const TIMEOUT = RPC_TIMEOUT + 10000;
export const POLLING_INTERVAL = 30000;
export const CHECK_SESSION_INTERVAL = 900 * 1000;

export default TIMEOUT;
